/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ReferenceDot,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
// material
import { Card } from '@mui/material';
//
import { Fragment } from 'react';
import moment from 'moment';
import {
  CustomTooltip,
  CustomReferenceDot,
  CustomReferenceDotWarning,
  getMomentAsNumber
} from './flightReviewUtils';
import { distance, pente } from '../../common/utils/calculFunction';

FlightReviewGraphLanding.propTypes = {
  positions: PropTypes.array,
  analyse: PropTypes.object,
  state: PropTypes.object,
  setState: PropTypes.func
};

export default function FlightReviewGraphLanding({ positions, analyse, state, setState }) {
  const item =
    state.selectedListItem !== -1 && state.currentPhase === 'atterrissages'
      ? analyse.analyseAtterrissageReports[state.selectedListItem]
      : {};
  const start = positions.indexOf(
    positions.find((position) => position.id === item.startPositionId)
  );
  const toucher = positions.indexOf(
    positions.find((position) => position.id === item.pointPositionId)
  );

  const end = positions.indexOf(
    positions.find(
      (position) =>
        position.id === (item.endPositionId === 0 ? item.pointPositionId : item.endPositionId)
    )
  );

  const position = positions.filter((_position, i) => i >= start && i <= end);

  const positionToucher = positions.filter((_position, i) => i >= start && i <= toucher);
  const calculPente = pente(positionToucher);
  const distanceTotal = distance(
    positionToucher.at(0),
    positionToucher.at(positionToucher.length - 1)
  );
  const CHART_DATA = position.map((item, index) => ({
    ...item,
    elevation:
      item.altitude - item.attributes.elevation < 0 ? item.altitude : item.attributes.elevation,
    distance: Math.floor(distance(positionToucher.at(0), item) - distanceTotal),
    pente5: index >= calculPente.length ? item.altitude : calculPente[index],
    fixTime: getMomentAsNumber(item.fixTime)
  }));

  return (
    <Card sx={{ height: '35vh', width: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          margin={{ top: 5, left: -50, right: -50, bottom: 0 }}
          data={CHART_DATA}
          onClick={(data) => {
            if (
              data !== undefined &&
              data !== null &&
              data.activePayload !== undefined &&
              data.activePayload[0] !== undefined &&
              data.activePayload[0].payload !== undefined &&
              data.activePayload[0].payload.id !== undefined
            ) {
              setState({
                ...state,
                currentPosition: positions.indexOf(
                  positions.find((position) => position.id === data.activePayload[0].payload.id)
                )
              });
            }
          }}
        >
          <Tooltip
            contentStyle={{}}
            content={<CustomTooltip currentPosition={positions[state.currentPosition]} />}
          />
          <CartesianGrid stroke="#000000" />
          <XAxis
            dataKey="fixTime"
            allowDuplicatedCategory={false}
            tickFormatter={(timeStr) => moment(timeStr).format('HH:mm')}
            type="number"
            domain={['auto', 'auto']}
            scale="time"
            tick={false}
          />
          <XAxis
            dataKey="distance"
            type="number"
            domain={['dataMin', 'dataMax']}
            allowDuplicatedCategory={false}
            tick={false}
          />
          <YAxis
            type="number"
            domain={['dataMin', 'dataMax']}
            tick={false}
            orientation="left"
            yAxisId="alt"
          />
          <YAxis
            type="number"
            domain={['dataMin', 'dataMax']}
            tick={false}
            orientation="right"
            yAxisId="spd"
          />
          <Line
            type="monotone"
            dataKey="altitude"
            name="altitude"
            key="altitude"
            stroke="#22398d"
            dot={false}
            activeDot={{ r: 5 }}
            strokeWidth={3}
            yAxisId="alt"
          />
          <Line
            type="monotone"
            dataKey="pente5"
            name="pente5%"
            key="pente5"
            stroke="#00561B"
            dot={false}
            activeDot={{ r: 5 }}
            strokeWidth={3}
            yAxisId="alt"
          />
          <Area
            type="monotone"
            dataKey="elevation"
            stroke="#c8ad7f"
            fill="#c8ad7f"
            dot={false}
            activeDot={{ r: 5 }}
            strokeWidth={3}
            yAxisId="alt"
          />
          <Line
            type="monotone"
            dataKey="speed"
            name="speed"
            key="speed"
            stroke="#e50e58"
            dot={false}
            activeDot={{ r: 5 }}
            strokeWidth={3}
            yAxisId="spd"
          />

          {analyse.analyseAtterrissageReports.map((item, index) => {
            const start = positions.indexOf(
              positions.find((position) => position.id === item.startPositionId)
            );

            const end = positions.indexOf(
              positions.find(
                (position) =>
                  position.id ===
                  (item.endPositionId === 0 ? item.pointPositionId : item.endPositionId)
              )
            );

            const toucher = positions.indexOf(
              positions.find((position) => position.id === item.pointPositionId)
            );

            const distanceTotal = distance(positions.at(start), positions.at(toucher));
            const alertSpeed =
              item.speedAlert !== 0
                ? positions.indexOf(positions.find((position) => position.id === item.speedAlert))
                : 0;
            const warningSpeed =
              item.speedWarning !== 0
                ? positions.indexOf(positions.find((position) => position.id === item.speedWarning))
                : 0;
            const alertG =
              item.gAlert !== 0
                ? positions.indexOf(positions.find((position) => position.id === item.gAlert))
                : 0;
            const warningG =
              item.gWarning !== 0
                ? positions.indexOf(positions.find((position) => position.id === item.gWarning))
                : 0;

            if (state.currentPosition >= start && state.currentPosition <= end) {
              return (
                <Fragment key={`Atterrissage ${index}`}>
                  {alertSpeed !== 0 && alertSpeed === state.currentPosition && (
                    <ReferenceDot
                      key={`alertSpeed ${index}`}
                      yAxisId="spd"
                      x={Math.floor(
                        distance(positions.at(start), positions.at(alertSpeed)) - distanceTotal
                      )}
                      y={positions.at(alertSpeed).speed}
                      shape={CustomReferenceDot}
                    />
                  )}
                  {warningSpeed !== 0 && warningSpeed === state.currentPosition && (
                    <ReferenceDot
                      key={`warningSpeed ${index}`}
                      yAxisId="spd"
                      x={Math.floor(
                        distance(positions.at(start), positions.at(warningSpeed)) - distanceTotal
                      )}
                      y={positions.at(warningSpeed).speed}
                      shape={CustomReferenceDotWarning}
                    />
                  )}
                  {alertG !== 0 && alertG === state.currentPosition && (
                    <ReferenceDot
                      key={`alertG ${index}`}
                      yAxisId="alt"
                      x={Math.floor(
                        distance(positions.at(start), positions.at(alertG)) - distanceTotal
                      )}
                      y={positions.at(alertG).speed}
                      shape={CustomReferenceDot}
                    />
                  )}
                  {warningG !== 0 && warningG === state.currentPosition && (
                    <ReferenceDot
                      key={`warningG ${index}`}
                      yAxisId="alt"
                      x={Math.floor(
                        distance(positions.at(start), positions.at(warningG)) - distanceTotal
                      )}
                      y={positions.at(warningG).speed}
                      shape={CustomReferenceDotWarning}
                    />
                  )}
                </Fragment>
              );
            }
            return null;
          })}
        </ComposedChart>
      </ResponsiveContainer>
    </Card>
  );
}
